/**
 * Photo / experience / insurance / digital / talent / coworking / villa / remittance
 * register chip labels — tuples [ko, en, vi, ru].
 */

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, v]) => {
    if (Array.isArray(v) && v.length >= 4) out[k] = v[langIndex];
    else if (v && typeof v === 'object' && !Array.isArray(v)) out[k] = pick(v, langIndex);
    else out[k] = v;
  });
  return out;
}

const photo = {
  typeWedding: ['웨딩/커플', 'Wedding / couple', 'Cưới / couple', 'Свадьба / пара'],
  typePortrait: ['프로필/증명', 'Portrait / ID', 'Chân dung / ID', 'Портрет / документы'],
  typeProduct: ['제품/음식', 'Product / food', 'Sản phẩm / món', 'Продукт / еда'],
  typeEvent: ['행사/이벤트', 'Event', 'Sự kiện', 'Мероприятие'],
  typeVideo: ['영상/편집', 'Video / edit', 'Video / dựng', 'Видео / монтаж'],
  typeDrone: ['드론 촬영', 'Drone', 'Flycam', 'Дрон'],
  typeTravel: ['여행/스냅', 'Travel / snap', 'Du lịch / snap', 'Тревел / снэп'],
  typeOther: ['기타', 'Other', 'Khác', 'Другое'],
  styleNatural: ['내추럴', 'Natural', 'Tự nhiên', 'Натуральный'],
  styleRomantic: ['로맨틱', 'Romantic', 'Lãng mạn', 'Романтика'],
  styleVintage: ['빈티지', 'Vintage', 'Cổ điển', 'Винтаж'],
  styleModern: ['모던', 'Modern', 'Hiện đại', 'Модерн'],
  styleMinimal: ['미니멀', 'Minimal', 'Tối giản', 'Минимал'],
  styleDark: ['다크무드', 'Dark mood', 'Tối', 'Тёмный муд'],
  styleBright: ['브라이트', 'Bright', 'Sáng', 'Светлый'],
  styleFilm: ['필름감성', 'Film look', 'Phim analog', 'Плёночный'],
  styleFood: ['푸드스타일링', 'Food styling', 'Tạo hình món', 'Фуд-стайлинг'],
  styleClean: ['클린', 'Clean', 'Sạch', 'Чистый'],
  styleDaylight: ['자연광', 'Natural light', 'Ánh sáng tự nhiên', 'Дневной свет'],
  styleStudio: ['스튜디오', 'Studio', 'Phòng studio', 'Студия'],
  styleDramatic: ['드라마틱', 'Dramatic', 'Kịch tính', 'Драма'],
  styleCandid: ['캔디드', 'Candid', 'Chụp tự nhiên', 'Кандид'],
  styleFashion: ['패션', 'Fashion', 'Thời trang', 'Мода'],
  incRaw: ['원본 파일 전체', 'All raw files', 'Toàn bộ file gốc', 'Все исходники'],
  incRetouch: ['리터칭/보정', 'Retouch', 'Chỉnh ảnh', 'Ретушь'],
  incInstant: ['즉시 전송', 'Instant delivery', 'Gửi ngay', 'Сразу отправить'],
  incUsb: ['USB 제공', 'USB copy', 'Bản USB', 'Копия на USB'],
  incAlbum: ['앨범 제작', 'Album', 'Làm album', 'Альбом'],
  incGallery: ['온라인 갤러리', 'Online gallery', 'Gallery online', 'Онлайн-галерея'],
  incCommercial: ['상업적 사용 허가', 'Commercial use', 'Dùng thương mại', 'Коммерческое право'],
  incColor: ['색보정', 'Color grade', 'Chỉnh màu', 'Цветокор'],
  incSubs: ['자막', 'Subtitles', 'Phụ đề', 'Субтитры'],
  incBgm: ['BGM', 'Background music', 'Nhạc nền', 'Фоновая музыка'],
  incThumb: ['썸네일', 'Thumbnail', 'Ảnh bìa', 'Превью'],
  incDress: ['드레스 대여 가능', 'Dress rental OK', 'Có thuê váy', 'Можно аренда платья'],
};

const exp = {
  regCooking: ['쿠킹클래스', 'Cooking class', 'Lớp nấu ăn', 'Кулинарный класс'],
  regCraft: ['공예/만들기', 'Craft', 'Thủ công', 'Ремесло'],
  regSports: ['스포츠/액티비티', 'Sports / activity', 'Thể thao', 'Спорт / активность'],
  regTour: ['투어/관광', 'Tour', 'Tham quan', 'Тур'],
  regWellness: ['요가/웰니스', 'Yoga / wellness', 'Yoga / sức khoẻ', 'Йога / велнес'],
  regFood: ['음식투어', 'Food tour', 'Tour ẩm thực', 'Гастротур'],
  regShow: ['공연/쇼', 'Show', 'Biểu diễn', 'Шоу'],
  regClass: ['클래스/교육', 'Class', 'Lớp học', 'Занятие'],
  regOther: ['기타', 'Other', 'Khác', 'Другое'],
  incMaterials: ['재료비', 'Materials', 'Nguyên liệu', 'Материалы'],
  incGuide: ['가이드', 'Guide', 'Hướng dẫn', 'Гид'],
  incPickup: ['픽업/드랍', 'Pickup / drop', 'Đón / trả', 'Трансфер'],
  incMeal: ['식사', 'Meal', 'Bữa ăn', 'Еда'],
  incTicket: ['입장료', 'Admission', 'Vé vào', 'Вход'],
  incGear: ['장비 대여', 'Gear rental', 'Thuê dụng cụ', 'Прокат снаряжения'],
  incPhoto: ['사진 촬영', 'Photos', 'Chụp ảnh', 'Фото'],
  incIns: ['보험', 'Insurance', 'Bảo hiểm', 'Страховка'],
  incProduct: ['완성품', 'Take-home item', 'Sản phẩm mang về', 'Готовое изделие'],
  incRecipe: ['레시피북', 'Recipe book', 'Sách công thức', 'Книга рецептов'],
};

const insurance = {
  typeHealth: ['건강보험', 'Health', 'Sức khỏe', 'Здоровье'],
  typeTravel: ['여행자보험', 'Travel', 'Du lịch', 'Путешествия'],
  typeLife: ['생명보험', 'Life', 'Nhân thọ', 'Жизнь'],
  typeCar: ['자동차보험', 'Auto', 'Xe', 'Авто'],
  typeHome: ['재산/화재보험', 'Property / fire', 'Tài sản / cháy', 'Имущество / пожар'],
  typeOther: ['기타', 'Other', 'Khác', 'Другое'],
  covHospital: ['입원비', 'Hospital stay', 'Nằm viện', 'Госпитализация'],
  covSurgery: ['수술비', 'Surgery', 'Phẫu thuật', 'Операция'],
  covOutpatient: ['외래진료', 'Outpatient', 'Ngoại trú', 'Амбулатория'],
  covEr: ['응급실', 'Emergency room', 'Cấp cứu', 'Скорая'],
  covMeds: ['약제비', 'Medicine', 'Thuốc', 'Лекарства'],
  covDental: ['치과', 'Dental', 'Nha khoa', 'Стоматология'],
  covEvac: ['의료후송', 'Medevac', 'Vận chuyển y tế', 'Медэвакуация'],
  covDeath: ['사망보험금', 'Death benefit', 'Tử vong', 'Выплата при смерти'],
  covDisability: ['장해보험금', 'Disability', 'Khuyết tật', 'Инвалидность'],
  covCritical: ['중대질병', 'Critical illness', 'Bệnh nặng', 'Крит. заболевание'],
  covThirdPerson: ['대인배상', 'Third-party injury', 'Bồi thường người', 'Вред людям'],
  covThirdProp: ['대물배상', 'Third-party property', 'Bồi thường tài sản', 'Вред имуществу'],
  covOwnCar: ['자차손해', 'Own vehicle', 'Xe mình', 'Своё авто'],
  covRoadside: ['긴급출동', 'Roadside assist', 'Cứu hộ', 'Помощь на дороге'],
  covDelay: ['항공지연', 'Flight delay', 'Delay chuyến bay', 'Задержка рейса'],
  covLost: ['휴대품분실', 'Lost items', 'Mất đồ', 'Утеря вещей'],
  covCancel: ['여행취소', 'Trip cancel', 'Huỷ tour', 'Отмена поездки'],
  covLiability: ['배상책임', 'Liability', 'Trách nhiệm', 'Ответственность'],
  dur1d: ['1일', '1 day', '1 ngày', '1 день'],
  dur7d: ['7일', '7 days', '7 ngày', '7 дней'],
  dur30d: ['30일', '30 days', '30 ngày', '30 дней'],
  dur3m: ['3개월', '3 months', '3 tháng', '3 месяца'],
  dur6m: ['6개월', '6 months', '6 tháng', '6 месяцев'],
  dur1y: ['1년', '1 year', '1 năm', '1 год'],
  dur3y: ['3년', '3 years', '3 năm', '3 года'],
  dur5y: ['5년', '5 years', '5 năm', '5 лет'],
  dur10y: ['10년', '10 years', '10 năm', '10 лет'],
  dur20y: ['20년', '20 years', '20 năm', '20 лет'],
};

const digital = {
  catWeb: ['웹사이트 제작', 'Website', 'Trang web', 'Сайт'],
  catApp: ['앱 개발', 'App dev', 'Làm app', 'Приложение'],
  catDesign: ['UI/UX 디자인', 'UI/UX design', 'Thiết kế UI/UX', 'Дизайн UI/UX'],
  catMkt: ['SNS 마케팅', 'SNS marketing', 'Marketing MXH', 'SMM'],
  catSeo: ['SEO/광고', 'SEO / ads', 'SEO / quảng cáo', 'SEO / реклама'],
  catData: ['데이터 분석', 'Data analysis', 'Phân tích dữ liệu', 'Аналитика'],
  catAuto: ['업무 자동화', 'Automation', 'Tự động hoá', 'Автоматизация'],
  catOther: ['기타 IT', 'Other IT', 'IT khác', 'Другое IT'],
  priceFixed: ['고정가', 'Fixed', 'Giá cố định', 'Фикс'],
  priceHourly: ['시간당', 'Hourly', 'Theo giờ', 'Почасово'],
  priceMonthly: ['월정액', 'Monthly', 'Theo tháng', 'В месяц'],
  incResponsive: ['반응형 디자인', 'Responsive', 'Giao diện đáp ứng', 'Адаптив'],
  incSeo: ['SEO 기본 설정', 'Basic SEO', 'SEO cơ bản', 'Базовый SEO'],
  incMaint: ['유지보수 1개월', '1 month support', 'Bảo trì 1 tháng', 'Поддержка 1 мес.'],
  incSource: ['소스코드 제공', 'Source code', 'Mã nguồn', 'Исходный код'],
  incFigma: ['피그마 파일', 'Figma file', 'Tệp Figma', 'Файл Figma'],
  incProto: ['프로토타입', 'Prototype', 'Bản mẫu', 'Прототип'],
  incGuide: ['디자인 가이드', 'Design guide', 'Guide thiết kế', 'Гайд по дизайну'],
  incStore: ['앱스토어 등록', 'Store listing', 'Đăng store', 'Публикация в сторе'],
  incPosts: ['포스팅 월 12회', '12 posts / month', '12 bài / tháng', '12 постов / мес.'],
  incAds: ['광고 셋업', 'Ad setup', 'Setup ads', 'Настройка рекламы'],
  incReport: ['월간 리포트', 'Monthly report', 'Báo cáo tháng', 'Месячный отчёт'],
  incRev3: ['수정 3회', '3 revisions', 'Sửa 3 lần', '3 правки'],
};

const talent = {
  catTranslate: ['통역/번역', 'Interpret / translate', 'Phiên dịch / dịch', 'Перевод'],
  catDesign: ['디자인', 'Design', 'Thiết kế', 'Дизайн'],
  catDev: ['IT/개발', 'IT / dev', 'CNTT', 'IT / разработка'],
  catLesson: ['레슨/교육', 'Lessons', 'Dạy', 'Уроки'],
  catWriting: ['작가/콘텐츠', 'Writing / content', 'Viết / nội dung', 'Тексты'],
  catVideo: ['사진/영상', 'Photo / video', 'Ảnh / video', 'Фото / видео'],
  catRepair: ['수리/설치', 'Repair / install', 'Sửa / lắp', 'Ремонт / монтаж'],
  catCleaning: ['청소/이사', 'Cleaning / moving', 'Dọn / chuyển', 'Уборка / переезд'],
  catOther: ['기타', 'Other', 'Khác', 'Другое'],
  rt1h: ['1시간 이내', 'Within 1 hour', 'Trong 1 giờ', 'В течение 1 часа'],
  rt24h: ['24시간 이내', 'Within 24 hours', 'Trong 24 giờ', 'В течение 24 часов'],
  rt2d: ['2일 이내', 'Within 2 days', 'Trong 2 ngày', 'В течение 2 дней'],
  rtNeg: ['협의', 'Negotiable', 'Thương lượng', 'По договорённости'],
};

const coworking = {
  spaceOpen: ['오픈 데스크', 'Open desk', 'Bàn mở', 'Открытый стол'],
  spacePrivate: ['독립 좌석', 'Private seat', 'Chỗ riêng', 'Отдельное место'],
  spaceMeeting: ['회의실', 'Meeting room', 'Phòng họp', 'Переговорка'],
  spaceBooth: ['폰부스', 'Phone booth', 'Buồng gọi', 'Телефон-будка'],
  spaceEvent: ['이벤트 홀', 'Event hall', 'Hội trường', 'Зал мероприятий'],
  amPrinter: ['프린터/스캐너', 'Printer / scanner', 'In / scan', 'Принтер / сканер'],
  amMeeting: ['회의실', 'Meeting room', 'Phòng họp', 'Переговорка'],
  amCoffee: ['커피/음료', 'Coffee / drinks', 'Cà phê / đồ uống', 'Кофе / напитки'],
  amAc: ['에어컨', 'Air con', 'Máy lạnh', 'Кондиционер'],
  amLocker: ['라커', 'Locker', 'Tủ', 'Локер'],
  amDual: ['듀얼모니터', 'Dual monitor', 'Hai màn hình', 'Два монитора'],
  amBooth: ['폰부스', 'Phone booth', 'Buồng gọi', 'Телефон-будка'],
  amShower: ['샤워실', 'Shower', 'Phòng tắm', 'Душ'],
  amPark: ['주차', 'Parking', 'Đậu xe', 'Парковка'],
  am24h: ['24시간', '24 hours', '24 giờ', '24 часа'],
  amKitchen: ['주방', 'Kitchen', 'Bếp', 'Кухня'],
  amMail: ['우편수령', 'Mail pickup', 'Nhận thư', 'Почта'],
  amLounge: ['휴게공간', 'Lounge', 'Khu nghỉ', 'Лаунж'],
};

const villa = {
  typePrivate: ['프라이빗', 'Private', 'Riêng', 'Приват'],
  typeBeach: ['해변', 'Beach', 'Biển', 'Пляж'],
  typeMountain: ['산뷰', 'Mountain view', 'Núi', 'Вид на горы'],
  typeShared: ['공유형', 'Shared', 'Chung', 'Общий'],
  poolPrivate: ['프라이빗 풀', 'Private pool', 'Hồ bơi riêng', 'Свой бассейн'],
  poolInfinity: ['인피니티 풀', 'Infinity pool', 'Hồ infinity', 'Инфинити'],
  poolShared: ['공용 풀', 'Shared pool', 'Hồ bơi chung', 'Общий бассейн'],
  amKitchen: ['풀키친', 'Full kitchen', 'Bếp đầy đủ', 'Полная кухня'],
  amSpa: ['스파', 'Spa', 'Dịch vụ spa', 'Спа'],
  amPark: ['주차', 'Parking', 'Đậu xe', 'Парковка'],
  amAc: ['에어컨', 'Air con', 'Máy lạnh', 'Кондиционер'],
  amBeach: ['해변근처', 'Near beach', 'Gần biển', 'У пляжа'],
  amGarden: ['정원', 'Garden', 'Vườn', 'Сад'],
  amGym: ['헬스', 'Gym', 'Phòng gym', 'Зал'],
  amEnt: ['엔터테인먼트', 'Entertainment', 'Giải trí', 'Развлечения'],
  amBaby: ['아기용품', 'Baby gear', 'Đồ em bé', 'Для малышей'],
  amPet: ['펫허용', 'Pets OK', 'Được thú cưng', 'Можно с питомцем'],
  amBbq: ['바베큐', 'BBQ', 'Nướng BBQ', 'Барбекю'],
  poolSizePh: ['예: 12m × 5m', 'e.g. 12m × 5m', 'VD: 12m × 5m', 'напр. 12м × 5м'],
};

const remittance = {
  ttInstant: ['즉시', 'Instant', 'Ngay', 'Мгновенно'],
  tt1h: ['1시간 이내', 'Within 1 hour', 'Trong 1 giờ', 'В течение 1 часа'],
  ttSame: ['당일', 'Same day', 'Trong ngày', 'В тот же день'],
  tt12: ['1-2일', '1–2 days', '1–2 ngày', '1–2 дня'],
  tt23: ['2-3일', '2–3 days', '2–3 ngày', '2–3 дня'],
  tt35: ['3-5일', '3–5 days', '3–5 ngày', '3–5 дней'],
};

function buildLang(i) {
  return {
    photo: pick(photo, i),
    exp: pick(exp, i),
    insurance: pick(insurance, i),
    digital: pick(digital, i),
    talent: pick(talent, i),
    coworking: pick(coworking, i),
    villa: pick(villa, i),
    remittance: pick(remittance, i),
  };
}

export const phaseLocalRegisterChips2Ko = buildLang(0);
export const phaseLocalRegisterChips2En = buildLang(1);
export const phaseLocalRegisterChips2Vi = buildLang(2);
export const phaseLocalRegisterChips2Ru = buildLang(3);
